<template>
  <el-select
    v-model="valueBackup"
    :clearable="clearable"
    :placeholder="placeholder"
    @change="handleChange"
    :multiple="multiple"
    filterable
    :disabled="disabled"
    :size="size"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.sort_name"
      :value="item.id"
      :disabled="disabledIds.includes(item.id)"
    />
  </el-select>
</template>

<script>
import { index } from '@/api/video-sort';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    clearable: Boolean,
    multiple: Boolean,
    placeholder: {
      type: String,
      default: '请选择视频分类',
    },
    disabled: Boolean,
    disabledIds: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    valueBackup: '',
    list: [],
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== (+this.valueBackup || '')) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== this.value) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    async getList() {
      const { isError, data } = await index({
        is_all: 1,
      });
      if (isError) return;

      this.list = data;
    },
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }
    this.getList();
  },
};
</script>
